import type {
  CreateCostPlaceMutation,
  CreateCostPlaceMutationVariables
} from './__generated__/CreateCostPlaceMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  CreateCostPlaceMutation,
  CreateCostPlaceMutationVariables
> = gql`
  mutation CreateCostPlaceMutation($input: CreateCostPlaceInput!) {
    createCostPlace(input: $input) {
      status
    }
  }
`

export function createCostPlaceMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      CreateCostPlaceMutation,
      CreateCostPlaceMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
